import { type CSSObject } from '@mui/material/styles';

import { grey } from '@theme/colors';

/**
 * Adds a border to all elevations in style object. Styles that already have a border won't be updated.
 */
export const addElevationBorder = (
  /** JSS styling to update with border */
  styles: CSSObject,
  /** Number of highest elevation */
  elevationsMax = 24,
  /** Value of border that should be added. */
  border = `1px solid ${grey[200]}`
): CSSObject => {
  for (let i = 1; i <= elevationsMax; i++) {
    styles[`elevation${i}`] = { border, ...(styles[`elevation${i}`] as object) };
  }

  return styles;
};
